import React from "react";
import View from "components/presentation/assistant/Assistant.view";

// The process's *visible* name, which is what `find_inherited_process` matches on: it
// lives in Core (`process/agents/help/WORKIX_ASSISTANT.py`), which every flow inherits,
// and the push titles the function name into this.
const ASSISTANT_PROCESS = "Workix Assistant";

/**
 * The help assistant, opened from the profile menu over whatever screen the person is on.
 *
 * It floats beside the page instead of covering it: reporting a problem means pointing at
 * it, and the screen capture the assistant opens has to see the screen, not a modal.
 * Each opening is a new conversation — one report per sitting.
 */
const Assistant = ({ flow, onClose }) => (
  <View flow={flow} processName={ASSISTANT_PROCESS} onClose={onClose} />
);

export default Assistant;
